import { render, staticRenderFns } from "./BatchOrderIndex.vue?vue&type=template&id=6c4bce78&scoped=true&"
import script from "./BatchOrderIndex.vue?vue&type=script&lang=js&"
export * from "./BatchOrderIndex.vue?vue&type=script&lang=js&"
import style0 from "./BatchOrderIndex.vue?vue&type=style&index=0&id=6c4bce78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4bce78",
  null
  
)

export default component.exports